import createAction from "../../app/createAction";
import {
    ACCOUNT_GET_PORTFOLIO_FAILURE,
    ACCOUNT_GET_PORTFOLIO_START,
    ACCOUNT_GET_PORTFOLIO_SUCCESS,
    ACCOUNT_GET_TRADING_TOKEN_FAILURE,
    ACCOUNT_GET_TRADING_TOKEN_START,
    ACCOUNT_GET_TRADING_TOKEN_SUCCESS,
    DEPOSIT_CREATE_COMPLETE,
    DEPOSIT_CREATE_FAILURE,
    DEPOSIT_CREATE_MOBILE_START,
    DEPOSIT_CREATE_SUCCESS,
    DEPOSIT_CREATE_WEB_START,
    GET_DEPOSIT_AVAILABLE_METHODS_FAILURE,
    GET_DEPOSIT_AVAILABLE_METHODS_START,
    GET_DEPOSIT_AVAILABLE_METHODS_SUCCESS,
    GET_DEPOSIT_FORM_FAILURE,
    GET_DEPOSIT_FORM_START,
    GET_DEPOSIT_FORM_SUCCESS,
    GET_DEPOSIT_PARAMS_FAILURE,
    GET_DEPOSIT_PARAMS_START,
    GET_DEPOSIT_PARAMS_SUCCESS,
    GET_DEPOSIT_SURVEY_FAILURE,
    GET_DEPOSIT_SURVEY_START,
    GET_DEPOSIT_SURVEY_SUCCESS,
    GET_PAYOUT_PARAMS_FAILURE,
    GET_PAYOUT_PARAMS_START,
    GET_PAYOUT_PARAMS_SUCCESS,
    PAYOUT_CREATE_FAILURE,
    PAYOUT_CREATE_START,
    PAYOUT_CREATE_SUCCESS,
    PAYOUT_GET_AVAILABLE_METHODS_FAILURE,
    PAYOUT_GET_AVAILABLE_METHODS_START,
    PAYOUT_GET_AVAILABLE_METHODS_SUCCESS,
    PAYOUT_GET_FORM_FAILURE,
    PAYOUT_GET_FORM_START,
    PAYOUT_GET_FORM_SUCCESS,
    PAYOUT_TRANSACTIONS_FAILURE,
    PAYOUT_TRANSACTIONS_START,
    PAYOUT_TRANSACTIONS_SUCCESS,
    RESEND_USER_CONFIRM_EMAIL_FAILURE,
    RESEND_USER_CONFIRM_EMAIL_START,
    RESEND_USER_CONFIRM_EMAIL_SUCCESS,
    RESET_ACCOUNT_ERROR,
    SEND_DEPOSIT_SURVEY_RESULT_FAILURE,
    SEND_DEPOSIT_SURVEY_RESULT_START,
    SEND_DEPOSIT_SURVEY_RESULT_SUCCESS,
    SET_ACCOUNT_SELECTED_HISTORY_INFO,
    SET_CONFIRM_EMAIL_REQUEST_TIME,
    SET_IS_CHECK_DEPOSIT_SURVEY,
} from "./accountConstants";

export const accountGetPortfolioAction = (payload) => createAction(ACCOUNT_GET_PORTFOLIO_START, payload);
export const accountGetPortfolioSuccess = (payload) => createAction(ACCOUNT_GET_PORTFOLIO_SUCCESS, payload);
export const accountGetPortfolioFailure = (payload) => createAction(ACCOUNT_GET_PORTFOLIO_FAILURE, payload);

export const accountGetTradingTokenAction = (payload) => createAction(ACCOUNT_GET_TRADING_TOKEN_START, payload);
export const accountGetTradingTokenSuccess = (payload) => createAction(ACCOUNT_GET_TRADING_TOKEN_SUCCESS, payload);
export const accountGetTradingTokenFailure = (payload) => createAction(ACCOUNT_GET_TRADING_TOKEN_FAILURE, payload);

export const getDepositParamsAction = (payload) => createAction(GET_DEPOSIT_PARAMS_START, payload);
export const getDepositParamsSuccess = (payload) => createAction(GET_DEPOSIT_PARAMS_SUCCESS, payload);
export const getDepositParamsFailure = (payload) => createAction(GET_DEPOSIT_PARAMS_FAILURE, payload);

export const getDepositAvailableMethodsAction = (payload) => createAction(GET_DEPOSIT_AVAILABLE_METHODS_START, payload);
export const getDepositAvailableMethodsSuccess = (payload) => createAction(GET_DEPOSIT_AVAILABLE_METHODS_SUCCESS, payload);
export const getDepositAvailableMethodsFailure = (payload) => createAction(GET_DEPOSIT_AVAILABLE_METHODS_FAILURE, payload);

export const depositCreateWebAction = (payload) => createAction(DEPOSIT_CREATE_WEB_START, payload);
export const depositCreateMobileAction = (payload) => createAction(DEPOSIT_CREATE_MOBILE_START, payload);
export const depositCreateSuccess = (payload) => createAction(DEPOSIT_CREATE_SUCCESS, payload);
export const depositCreateFailure = (payload) => createAction(DEPOSIT_CREATE_FAILURE, payload);
export const depositCreateComplete = (payload) => createAction(DEPOSIT_CREATE_COMPLETE, payload);

export const getDepositSurveyStartAction = (payload) => createAction(GET_DEPOSIT_SURVEY_START, payload);
export const getDepositSurveySuccess = (payload) => createAction(GET_DEPOSIT_SURVEY_SUCCESS, payload);
export const getDepositSurveyFailure = (payload) => createAction(GET_DEPOSIT_SURVEY_FAILURE, payload);

export const setIsCheckDepositSurvey = (payload) => createAction(SET_IS_CHECK_DEPOSIT_SURVEY, payload);

export const sendDepositSurveyResultStartAction = (payload) => createAction(SEND_DEPOSIT_SURVEY_RESULT_START, payload);
export const sendDepositSurveyResultSuccess = (payload) => createAction(SEND_DEPOSIT_SURVEY_RESULT_SUCCESS, payload);
export const sendDepositSurveyResultFailure = (payload) => createAction(SEND_DEPOSIT_SURVEY_RESULT_FAILURE, payload);

export const getDepositFormAction = (payload) => createAction(GET_DEPOSIT_FORM_START, payload);
export const getDepositFormSuccess = (payload) => createAction(GET_DEPOSIT_FORM_SUCCESS, payload);
export const getDepositFormFailure = (payload) => createAction(GET_DEPOSIT_FORM_FAILURE, payload);

export const getPayoutParamsAction = (payload) => createAction(GET_PAYOUT_PARAMS_START, payload);
export const getPayoutParamsSuccess = (payload) => createAction(GET_PAYOUT_PARAMS_SUCCESS, payload);
export const getPayoutParamsFailure = (payload) => createAction(GET_PAYOUT_PARAMS_FAILURE, payload);

export const payoutGetTransactionsAction = (payload) => createAction(PAYOUT_TRANSACTIONS_START, payload);
export const payoutGetTransactionsSuccess = (payload) => createAction(PAYOUT_TRANSACTIONS_SUCCESS, payload);
export const payoutGetTransactionsFailure = (payload) => createAction(PAYOUT_TRANSACTIONS_FAILURE, payload);

export const payoutGetAvailableMethodsAction = (payload) => createAction(PAYOUT_GET_AVAILABLE_METHODS_START, payload);
export const payoutGetAvailableMethodsSuccess = (payload) => createAction(PAYOUT_GET_AVAILABLE_METHODS_SUCCESS, payload);
export const payoutGetAvailableMethodsFailure = (payload) => createAction(PAYOUT_GET_AVAILABLE_METHODS_FAILURE, payload);

export const payoutGetFormAction = (payload) => createAction(PAYOUT_GET_FORM_START, payload);
export const payoutGetFormSuccess = (payload) => createAction(PAYOUT_GET_FORM_SUCCESS, payload);
export const payoutGetFormFailure = (payload) => createAction(PAYOUT_GET_FORM_FAILURE, payload);

export const payoutCreateAction = (payload) => createAction(PAYOUT_CREATE_START, payload);
export const payoutCreateSuccess = (payload) => createAction(PAYOUT_CREATE_SUCCESS, payload);
export const payoutCreateFailure = (payload) => createAction(PAYOUT_CREATE_FAILURE, payload);

export const resetAccountErrorAction = (payload) => createAction(RESET_ACCOUNT_ERROR, payload);

export const resendUserConfirmEmailAction = (payload) => createAction(RESEND_USER_CONFIRM_EMAIL_START, payload);
export const resendUserConfirmEmailSuccess = (payload) => createAction(RESEND_USER_CONFIRM_EMAIL_SUCCESS, payload);
export const resendUserConfirmEmailFailure = (payload) => createAction(RESEND_USER_CONFIRM_EMAIL_FAILURE, payload);

export const setConfirmEmailRequestedTimeAction = (payload) => createAction(SET_CONFIRM_EMAIL_REQUEST_TIME, payload);

export const setAccountSelectedHistoryInfoAction = (payload) => createAction(SET_ACCOUNT_SELECTED_HISTORY_INFO, payload);
